// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__v3m9v","description":"style_description__3ucmx","edit":"style_edit__HDUb5","comment":"style_comment__u5qXf","error":"style_error__yGkvz"};